unit SMX.Format.Conversion;

interface

uses
  System.SysUtils;

type
  TNumberFormatUtils = class
  public
    class function DetectAndConvertNumber(const Input: string; out Number: Double): Boolean;
  end;

implementation

class function TNumberFormatUtils.DetectAndConvertNumber(const Input: string; out Number: Double): Boolean;
var
  Cleaned: string;
  DecimalSep: Char;
  ThousandSep: Char;
  CommaCount, DotCount: Integer;
  LastComma, LastDot: Integer;
  TailLen: Integer;
begin
  Result := False;
  CommaCount := Length(Input) - Length(StringReplace(Input, ',', '', [rfReplaceAll]));
  DotCount := Length(Input) - Length(StringReplace(Input, '.', '', [rfReplaceAll]));
  LastComma := LastDelimiter(',', Input);
  LastDot := LastDelimiter('.', Input);

  DecimalSep := '.';
  ThousandSep := ',';

  if (CommaCount > 0) and (DotCount > 0) then
  begin
    if LastComma > LastDot then
    begin
      DecimalSep := ',';
      ThousandSep := '.';
    end
    else
    begin
      DecimalSep := '.';
      ThousandSep := ',';
    end;
  end
  else if (CommaCount = 1) and (DotCount = 0) then
  begin
    TailLen := Length(Input) - LastComma;
    if TailLen = 2 then
    begin
      DecimalSep := ','; // e.g. 100,00
      ThousandSep := '.'; // just to avoid misdetection
    end
    else if TailLen = 3 then
    begin
      ThousandSep := ',';
      DecimalSep := '.';
    end;
  end
  else if (DotCount = 1) and (CommaCount = 0) then
  begin
    TailLen := Length(Input) - LastDot;
    if TailLen = 2 then
    begin
      DecimalSep := '.';
      ThousandSep := ',';
    end
    else if TailLen = 3 then
    begin
      ThousandSep := '.';
      DecimalSep := ',';
    end;
  end
  else if (CommaCount = 0) and (DotCount = 0) then
  begin
    DecimalSep := '.';
    ThousandSep := ',';
  end;

  Cleaned := StringReplace(Input, ThousandSep, '', [rfReplaceAll]);
  Cleaned := StringReplace(Cleaned, DecimalSep, '.', [rfReplaceAll]);

  Result := TryStrToFloat(Cleaned, Number);
end;

end.
